import {externalApiURL} from '@logistics-frontend/client-core/api/corp'
import {fetch} from '@logistics-frontend/core/utils/network'
import {createSuggestRepository} from '@yandex-delivery/api/repo/suggest'
import {createSuggestService} from '@yandex-delivery/api/service/suggest'

type FetchFunction = typeof fetch

const withExternalApiPrefix = (fetch: FetchFunction): FetchFunction => {
  return config => {
    return fetch({
      ...config,
      url: externalApiURL(config.url),
    })
  }
}

const suggestRepository = createSuggestRepository({fetch: withExternalApiPrefix(fetch)})

export const suggestService = createSuggestService(suggestRepository)
